import React from 'react';
import PropTypes from 'prop-types';

export default function StockTickerRightColumn(props) {

  const{
    rangeDates,
    volume
  } = props.meta.data;
  const{
    styles,
    _styles,
    ulStyle,
    liStyle,
    liFormat,
    labelFormat
  } = props.meta.styles;
  const{
    rangeLabel,
    avgVolumeLabel,
    avgVolumeValue,
    formatNumber
  } = props.meta;
  return (
    <ul style={ulStyle} className={styles.rightColumn}>
      <li className={[styles.datepickerRange, _styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          Range <small>({rangeLabel})</small>
        </span>
        <span id="range2Value" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( rangeDates[0], 'decimal' )}
          <span className={_styles.dash}> - </span>
          {formatNumber( rangeDates[1], 'decimal' )}
        </span>
      </li>
      <li className={[styles.volumeNow,_styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          Volume
        </span>
        <span id="volumeValue" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( parseFloat(volume), 'int' )}
        </span>
      </li>
      <li className={[styles.averageVolume,_styles.listLI, liFormat].join(' ')}>
        <span className={[_styles.stocksLabel, labelFormat].join(' ')}>
          {avgVolumeLabel}
        </span>
        <span id="avgVolumeValue" style={liStyle} className={[_styles.stocksValue].join(' ')}>
          {formatNumber( parseFloat(avgVolumeValue), 'int' )}
        </span>
      </li>
    </ul>
  );
}

StockTickerRightColumn.propTypes = {
  meta: PropTypes.object
};
